import { Pipe, PipeTransform } from '@angular/core';

export type EqualOr<T> = ProposalFieldState.EQUAL | T;

export enum ProposalFieldState {
  EQUAL = 'EQUAL',
}

@Pipe({ standalone: false, name: 'isEqual' })
export class IsEqualPipe implements PipeTransform {
  transform<T>(value: EqualOr<T>): boolean {
    return value === ProposalFieldState.EQUAL;
  }
}
